import * as Types from '../../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateCourseMutationVariables = Types.Exact<{
  input: Types.UpdateCourseInput;
}>;


export type UpdateCourseMutation = { __typename?: 'MutationRoot', updateCourse: { __typename?: 'Course', id: string, name: string, isVisibleToAllUserGroups: boolean } };

export type CreateHyperlapseMutationVariables = Types.Exact<{
  input: Types.GenerateHyperlapseInput;
}>;


export type CreateHyperlapseMutation = { __typename?: 'MutationRoot', generateHyperlapse: { __typename?: 'Hyperlapse', id: string } };


export const UpdateCourseDocument = gql`
    mutation UpdateCourse($input: UpdateCourseInput!) {
  updateCourse(input: $input) {
    id
    name
    isVisibleToAllUserGroups
  }
}
    `;

export function useUpdateCourseMutation() {
  return Urql.useMutation<UpdateCourseMutation, UpdateCourseMutationVariables>(UpdateCourseDocument);
};
export const CreateHyperlapseDocument = gql`
    mutation CreateHyperlapse($input: GenerateHyperlapseInput!) {
  generateHyperlapse(input: $input) {
    id
  }
}
    `;

export function useCreateHyperlapseMutation() {
  return Urql.useMutation<CreateHyperlapseMutation, CreateHyperlapseMutationVariables>(CreateHyperlapseDocument);
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCourseMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateCourse })
 *   )
 * })
 */
export const mockUpdateCourseMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateCourseMutationVariables>, GraphQLContext<UpdateCourseMutation>, any>) =>
  graphql.mutation<UpdateCourseMutation, UpdateCourseMutationVariables>(
    'UpdateCourse',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateHyperlapseMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ generateHyperlapse })
 *   )
 * })
 */
export const mockCreateHyperlapseMutation = (resolver: ResponseResolver<GraphQLRequest<CreateHyperlapseMutationVariables>, GraphQLContext<CreateHyperlapseMutation>, any>) =>
  graphql.mutation<CreateHyperlapseMutation, CreateHyperlapseMutationVariables>(
    'CreateHyperlapse',
    resolver
  )
